export default "__VITE_ASSET__CchnF9Q1__"